import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { TextField, Loadable } from "components/support";
import { debounce } from "util";

class Filter extends Component {
  state = {
    legal_name: "",
    cnpj: "",
    name: "",
    email: "",
    phone: ""
  };

  handleField = (field, value) => {
    const { onFilter } = this.props;
    this.setState({ [field]: value }, debounce(() => onFilter(this.state)));
  };

  render() {
    const { legal_name, cnpj, name, email, phone } = this.state;

    return (
      <Paper elevation={1} className="p-sm mb-md">
        <Loadable loading={this.props.loading}>
          <Typography type="headline">Filtro</Typography>
          <Row between="xs">
            <Col xs={12} sm={6} md>
              <TextField
                allowClear
                fullWidth
                label="Razão Social"
                value={legal_name}
                onChange={(_, value) => this.handleField("legal_name", value)}
              />
            </Col>
            <Col xs={12} sm={6} md>
              <TextField
                allowClear
                fullWidth
                label="Nome Fantasia"
                value={name}
                onChange={(_, value) => this.handleField("name", value)}
              />
            </Col>
            <Col xs={12} sm={6} md>
              <TextField
                allowClear
                fullWidth
                label="CNPJ"
                value={cnpj}
                onChange={(_, value) => this.handleField("cnpj", value)}
              />
            </Col>
            <Col xs={12} sm={6} md>
              <TextField
                allowClear
                fullWidth
                label="E-mail"
                value={email}
                onChange={(_, value) => this.handleField("email", value)}
              />
            </Col>
            <Col xs={12} sm={6} md>
              <TextField
                allowClear
                fullWidth
                label="Telefone"
                value={phone}
                onChange={(_, value) => this.handleField("phone", value)}
              />
            </Col>
          </Row>
        </Loadable>
      </Paper>
    );
  }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/filter/index.js